import { createFileRoute } from '@tanstack/react-router'
import { ContactPage } from '../components/pages/ContactPage'
import { throwLegacyRedirect } from '../lib/legacy-redirect'
import { publicPageHead } from '../lib/seo'

export const Route = createFileRoute('/contact')({
  beforeLoad: ({ location }) => {
    throwLegacyRedirect(location.pathname, location.searchStr)
  },
  component: ContactRoute,
  head: () => publicPageHead({
    title: 'Contact Autoglow Detailing | Geelong & Bellarine',
    description:
      'Contact Autoglow in Drysdale for ceramic coating and car detailing in Geelong. Send a message or call the studio to arrange an assessment.',
    path: '/contact',
    ogTitle: 'Contact Autoglow Detailing',
  }),
})

function ContactRoute() {
  return <ContactPage />
}
